<template>
  <div v-if="!$context.is.align">
    <div class="opc-cart-item__text" :class="{'opc-cart-item__full-term': isFullTerm}" v-if="mx_is && nextBillingDate">
      <span style="vertical-align: middle" class="text-capitalize">
        {{ chargeLabel }}
        <vloader :loading="mx_loading" :value="displayPeriod" />
      </span>
      <zm-tooltip
        v-if="!isFullTerm && !mx_loading"
        :content="proratedPeriodTips"
        role="button"
        disallow-learn-about
        aria-label="Learn more about Prorated charge"
      >
        <tips-icon type="info" aria-label="Learn more about Prorated charge" />
      </zm-tooltip>
      <zm-banner v-if="$context.is.add2cart && isFullTerm && displayAlignInfo && !isMultipleSubscriptionAccount" class="opc-cart-item__align-info" :content="displayAlignInfo" type="warning" show-icon :show-close="false"/>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
import { dateTimeFormat } from '@/utils/dateformat';
import { mapGetters } from 'vuex';
import mx from './mx.vue';
import vloader from './vloader.vue';
import { PRORATED_OF } from '@/store/modules/preview';
import { BILLING_CYCLE } from '@/common/constants';
import { getBasePlanInfo } from '@/common/product';
import moment from 'moment';
export default {
  mixins: [mx],
  components: {
    vloader,
  },
  data(){
    return {
    }
  },
  computed: {
    ...mapGetters(['getProratedChargeDetails', 'getSelectedPlans', 'boughtPlans', 'getSubscriptions', 'isMultipleSubscriptionAccount']),
    currentDate() {
      return dateTimeFormat(new Date());
    },
    nextBillingDate() {
      const found = this.getProratedChargeDetails.find((x) => x.of == PRORATED_OF.UPDATED && x.planCode === this.mx_cartPlan.plan_code);
      if (!found) return '';
      return dateTimeFormat(new Date(found.prorationEndDate));
    },
    isFullTerm(){
      const found = this.getProratedChargeDetails.find((x) => x.of == PRORATED_OF.UPDATED && x.planCode === this.mx_cartPlan.plan_code);
      if(found?.fullTerm) return true;
      return false;
    },
    chargeLabel(){
      if(this.isFullTerm){
        const billingCycle = this.getSelectedPlans.find(x => x.plan_code == this.mx_cartPlan.plan_code)?.billing_cycle
        if(billingCycle == BILLING_CYCLE.ANNUAL){
          // TODO current scope: it would be annual only
          return `${this.$t("billing.order_summary.annual_subscription")}: `
        }
      }
      return this.$t("billing.prorated.charged_period");
    },
    displayPeriod() {
      return `${this.currentDate} - ${this.nextBillingDate}`;
    },
    displayAlignInfo(){
      const currentBasePlans = getBasePlanInfo(this.boughtPlans);
      const basePlan = currentBasePlans?.plans?.[0];
      const basePlanInSub = this.getSubscriptions.find(x => x.plan_code == basePlan?.plan_code);
      if(!basePlanInSub) return '';
      const basePlanName = this.$t(basePlan.planNameKey);
      const renewTime = moment(new Date(basePlanInSub.planExpireTime));
      const curPlanName = this.$t(this.mx_cartPlan.planNameKey);
      return this.$t("billing.align.update_tip", {base: basePlanName, addon: curPlanName, date: dateTimeFormat(renewTime)});
    },
    proratedPeriodTips() {
      return this.mx_is_annual_term_monthly ?
        this.$t('billing.prorated.prorated_period_tooltip_annual_term_monthly', {
          period: this.displayPeriod
        }) :
        this.$t('billing.prorated.prorated_period_tooltip');
    }
  },
};
</script>

<style lang="scss">
.opc-cart-item:not(:has(.opc-cart-item__group)):has(.opc-cart-item__full-term) .opc-cart-item__cycle{
  display: none;
}
.opc-cart-item__group:has(.opc-cart-item__full-term) .opc-cart-item__cycle{
  display: none;
}
.opc-cart-item__full-term .opc-cart-item__align-info{
  background: #DFEAFF;
  margin-top: 12px;
}
.opc-cart-item{
  .opc-cart-item__group{
    .opc-cart-item__align-info{
      display: none;
    }
    &:last-child{
      .opc-cart-item__align-info{
        display: flex;
      }
    }
  }
}
</style>
